/**
 * 28px ghost copy icon button — glyph swaps to a success-colored check for
 * 3s on copy, button keeps its box (no layout shift).
 */
import { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import { copyPlainTextToClipboard } from "../../../../../helpers/clipboard";
import Icon from "../../../theme/untitled/icons/Icon";
import Tooltip from "../../../theme/untitled/Tooltip/Tooltip";
import styles from "./CopyButton.module.scss";

export const CopyButton = ({ value }) => {
  const [showCopied, setShowCopied] = useState(false);

  useEffect(() => {
    if (showCopied) {
      const timer = setTimeout(() => setShowCopied(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showCopied]);

  const onClick = useCallback(async (e) => {
    e.preventDefault();
    await copyPlainTextToClipboard(value);
    setShowCopied(true);
  }, [value]);

  return (
    <Tooltip content={showCopied ? "Copied" : "Copy to clipboard"}>
      <button
        type="button"
        className={classNames(styles.root, { [styles["is-copied"]]: showCopied })}
        onClick={onClick}
        aria-label="Copy to clipboard"
      >
        <Icon name={showCopied ? "Check" : "Copy01"} size={16} />
      </button>
    </Tooltip>
  );
};

export default CopyButton;
